/* Patches That Work — Daily theme behaviour */
(function () {
  'use strict';
  const cfg = window.PTW || {};
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = cfg.money_format || '£{{amount}}';
    const amount = (cents / 100).toFixed(2);
    const commas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, commas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toLocaleString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toLocaleString());
  }

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]'); if (!el) return;
    $('[data-toast-text]', el).textContent = msg;
    el.classList.add('is-on'); clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 3200);
  }

  /* ---------- overlays (drawers) ---------- */
  const overlay = {
    current: null,
    open(el) {
      if (!el) return;
      if (this.current && this.current !== el) this.close(true);
      this.current = el;
      el.removeAttribute('hidden');
      requestAnimationFrame(() => el.classList.add('is-open'));
      const scrim = $('[data-scrim]');
      if (scrim) { scrim.removeAttribute('hidden'); requestAnimationFrame(() => scrim.classList.add('is-open')); }
      if (!document.body.classList.contains('is-locked')) { this.scrollY = window.scrollY; document.body.style.top = -this.scrollY + 'px'; document.body.classList.add('is-locked'); }
      el.setAttribute('aria-hidden', 'false');
      const f = el.querySelector('[autofocus], button, a[href], input, select');
      if (f) setTimeout(() => f.focus({ preventScroll: true }), 120);
      document.addEventListener('keydown', onEsc);
    },
    close(silent) {
      const el = this.current; if (!el) return;
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
      setTimeout(() => { if (!el.classList.contains('is-open')) el.setAttribute('hidden', ''); }, 360);
      this.current = null;
      if (!silent) {
        const scrim = $('[data-scrim]');
        if (scrim) { scrim.classList.remove('is-open'); setTimeout(() => scrim.setAttribute('hidden', ''), 320); }
        document.body.classList.remove('is-locked'); document.body.style.top = '';
        window.scrollTo({ top: this.scrollY || 0, behavior: 'instant' });
        document.removeEventListener('keydown', onEsc);
      }
    }
  };
  function onEsc(e) { if (e.key === 'Escape') overlay.close(); }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); overlay.open(document.getElementById(opener.dataset.open)); return; }
    if (e.target.closest('[data-close-overlay]') || e.target.matches('[data-scrim]')) { e.preventDefault(); overlay.close(); }
  });

  /* ---------- bundle pricing (Kaching) ---------- */
  // Kaching's automatic discount only prices lines tagged the way its own widget tags them: the first
  // pouch is "main" and names the deal bar, every other pouch is a collection-break line, and all of
  // them share a group id. Untagged lines pay full price.
  const bundles = cfg.bundles || { tiers: [] };
  const KACHING = '__kaching_bundles';
  function bundleTier(qty) {
    if (!bundles.deal) return null;
    return bundles.tiers.find((t) => t.qty === qty && t.bar && t.price > 0) || null;
  }
  function subPrice(cents) { return Math.round(cents * (100 - Number(cfg.sub_percent || 0)) / 100); }
  // Kaching sets a fixed price for the pack; the subscription % then comes off that.
  function bundleNet(gross, qty, isSub) {
    const t = bundleTier(qty);
    const net = t && t.price < gross ? t.price : gross;
    return isSub ? subPrice(net) : net;
  }
  // units: one { variant, product, plan } per pouch.
  function bundleLines(units, name) {
    const tier = bundleTier(units.length), group = Math.random().toString(36).slice(2, 6), lines = [];
    units.forEach((u, i) => {
      const props = {};
      if (tier) {
        const tag = i === 0
          ? { deal: bundles.deal, pp: Number(u.product), main: true, id: group, bid: tier.bar }
          : { id: group, deal: bundles.deal, collectionBreaksProduct: true };
        if (u.plan) tag.sellingPlan = { id: Number(u.plan), priceAdjustment: { type: 'percentage', value: Number(cfg.sub_percent || 0) } };
        props[KACHING] = JSON.stringify(tag);
      }
      if (name) props._bundle = name;
      const line = { id: Number(u.variant), quantity: 1, properties: props };
      if (u.plan) line.selling_plan = Number(u.plan);
      const same = lines.find((l) => l.id === line.id && l.selling_plan === line.selling_plan && JSON.stringify(l.properties) === JSON.stringify(props));
      if (same) same.quantity++; else lines.push(line);
    });
    return lines;
  }

  /* ---------- cart ---------- */
  const cart = {
    state: null,
    async fetchState() {
      const r = await fetch(cfg.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      this.state = await r.json(); return this.state;
    },
    async add(items) {
      const list = Array.isArray(items) ? items : [items];
      // The flag tells Kaching's storefront script (if its app embed is on) to let our tagged add through untouched.
      const tagged = list.some((it) => it.properties && it.properties[KACHING]);
      const r = await fetch(cfg.routes.cart_add + '.js' + (tagged ? '?kaching_bundles=true' : ''), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || cfg.strings.error);
      await this.refresh(); return d;
    },
    async post(route, payload) {
      const r = await fetch(route + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || cfg.strings.error);
      this.state = d; await this.refresh(); return d;
    },
    change(payload) { return this.post(cfg.routes.cart_change, payload); },
    // Removing one pouch from a Kaching pack drops the discount on the rest, so packs come out together.
    async removeBundle(group) {
      const state = await this.fetchState(), updates = {};
      state.items.forEach((it) => { const tag = it.properties && it.properties[KACHING]; if (tag && tag.indexOf('"id":"' + group + '"') > -1) updates[it.key] = 0; });
      return this.post(cfg.routes.cart_update, { updates });
    },
    async refresh() {
      const r = await fetch(cfg.routes.cart + '?section_id=cart-drawer');
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      ['[data-cart-body]', '[data-cart-foot]'].forEach((sel) => {
        const fresh = doc.querySelector(sel), target = document.querySelector(sel);
        if (fresh && target) { target.innerHTML = fresh.innerHTML; target.hidden = fresh.hidden; }
      });
      await this.fetchState(); this.paintCount();
      document.dispatchEvent(new CustomEvent('ptw:cart:updated', { detail: this.state }));
      if (document.body.classList.contains('template-cart')) {
        const pr = await fetch(cfg.routes.cart + '?section_id=main-cart');
        const pdoc = new DOMParser().parseFromString(await pr.text(), 'text/html');
        const src = pdoc.querySelector('[data-cart-page]'), dst = document.querySelector('[data-cart-page]');
        if (src && dst) dst.innerHTML = src.innerHTML;
      }
    },
    paintCount() {
      const n = this.state ? this.state.item_count : 0;
      $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
      $$('[data-cart-count-text]').forEach((el) => { el.textContent = '(' + n + ')'; });
    },
    open() { overlay.open(document.getElementById('cart-drawer')); }
  };
  window.PTWCart = cart;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]'); if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId; if (!id) return;
    btn.classList.add('loading');
    try {
      const item = { id: Number(id), quantity: Number(btn.dataset.quantity || 1) };
      if (btn.dataset.sellingPlan) item.selling_plan = Number(btn.dataset.sellingPlan);
      await cart.add(item); cart.open();
    } catch (err) { toast(err.message); } finally { btn.classList.remove('loading'); }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]'); if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-atc]'); if (btn) btn.classList.add('loading');
    try {
      const fd = new FormData(form);
      if (!fd.get('selling_plan')) fd.delete('selling_plan');
      const qty = Number(fd.get('quantity') || 1);
      if (bundleTier(qty) && form.dataset.productId) {
        const unit = { variant: fd.get('id'), product: form.dataset.productId, plan: fd.get('selling_plan') };
        await cart.add(bundleLines(Array.from({ length: qty }, () => unit), qty + '-pack'));
      } else {
        const r = await fetch(cfg.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        const d = await r.json();
        if (!r.ok) throw new Error(d.description || d.message || cfg.strings.error);
        await cart.refresh();
      }
      cart.open();
    } catch (err) { toast(err.message); } finally { if (btn) btn.classList.remove('loading'); }
  });

  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = step.closest('[data-qty]').querySelector('input');
      input.value = Math.max(0, Number(input.value) + Number(step.dataset.qtyStep));
      input.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      const group = rm.dataset.cartBundle;
      (group ? $$('.cart-line[data-bundle-group="' + group + '"]') : [rm.closest('.cart-line')]).forEach((li) => li && li.classList.add('loading'));
      try { await (group ? cart.removeBundle(group) : cart.change({ id: rm.dataset.cartRemove, quantity: 0 })); } catch (err) { toast(err.message); }
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-cart-qty]'); if (!input) return;
    input.closest('.cart-line')?.classList.add('loading');
    try { await cart.change({ id: input.dataset.cartQty, quantity: Number(input.value) }); } catch (err) { toast(err.message); }
  });

  /* ---------- header: mega menu + hide on scroll ---------- */
  function initHeader() {
    const header = $('[data-header]'); if (!header) return;
    const setOffset = () => document.documentElement.style.setProperty('--header-offset', (header.closest('.is-sticky') ? header.offsetHeight : 0) + 'px');
    setOffset(); window.addEventListener('resize', setOffset);

    $$('[data-mega]').forEach((item) => {
      const link = item.querySelector('.nav__link');
      let t;
      const open = () => { clearTimeout(t); $$('[data-mega].is-open').forEach((o) => { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); };
      const close = () => { t = setTimeout(() => { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 140); };
      item.addEventListener('mouseenter', open); item.addEventListener('mouseleave', close);
      link.addEventListener('click', (e) => { if (window.matchMedia('(hover: none)').matches || e.detail === 0) { e.preventDefault(); item.classList.contains('is-open') ? item.classList.remove('is-open') : open(); } });
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('[data-mega].is-open').forEach((o) => o.classList.remove('is-open')); });

    let last = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 260 && y > last + 8 && !$('[data-mega].is-open')) header.style.transform = 'translateY(-102%)';
      else if (y < last - 8 || y < 120) header.style.transform = '';
      last = y;
    }, { passive: true });
  }

  /* ---------- hero slideshow ---------- */
  class Hero {
    constructor(root) {
      this.root = root; this.slides = $$('.hero__slide', root); this.i = 0;
      if (this.slides.length < 2) return;
      this.dots = $$('[data-hero-dot]', root);
      const remote = $('[data-hero-dots-remote]');
      if (remote) {
        remote.innerHTML = this.slides.map((_, n) => '<button type="button" data-hero-dot aria-label="Slide ' + (n + 1) + '" aria-current="' + (n === 0 ? 'true' : 'false') + '"></button>').join('');
        this.dots = this.dots.concat($$('[data-hero-dot]', remote));
        root.classList.add('has-remote-dots');
      }
      $$('[data-hero-nav]', root).forEach((b) => b.addEventListener('click', () => this.go(this.i + Number(b.dataset.heroNav))));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(Array.prototype.indexOf.call(d.parentNode.children, d))));
      const auto = Number(root.dataset.autoplay || 0);
      if (auto > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const play = () => { clearInterval(this.timer); this.timer = setInterval(() => this.go(this.i + 1), auto * 1000); };
        const pause = () => clearInterval(this.timer);
        play();
        root.addEventListener('mouseenter', pause); root.addEventListener('mouseleave', play);
        root.addEventListener('focusin', pause); root.addEventListener('focusout', play);
        document.addEventListener('visibilitychange', () => (document.hidden ? pause() : play()));
        this.restart = play;
      }
    }
    go(n) {
      const len = this.slides.length; this.i = ((n % len) + len) % len;
      if (this.restart && this.timer) this.restart();
      this.slides.forEach((s, k) => s.classList.toggle('is-on', k === this.i));
      (this.dots || []).forEach((d) => d.setAttribute('aria-current', Array.prototype.indexOf.call(d.parentNode.children, d) === this.i ? 'true' : 'false'));
    }
  }

  /* ---------- product gallery ---------- */
  class Gallery {
    constructor(root) {
      this.root = root; this.vp = $('[data-gallery-viewport]', root);
      this.slides = $$('.gallery__slide', root); this.thumbs = $$('[data-gallery-thumb]', root); this.i = 0;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      $$('[data-gallery-nav]', root).forEach((b) => b.addEventListener('click', () => this.go(this.i + Number(b.dataset.galleryNav))));
      if (this.vp) { let t; this.vp.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => this.mark(Math.round(this.vp.scrollLeft / this.vp.clientWidth)), 80); }, { passive: true }); }
    }
    go(i) { const n = this.slides.length; if (!n) return; this.i = ((i % n) + n) % n; this.vp.scrollTo({ left: this.vp.clientWidth * this.i, behavior: 'smooth' }); this.mark(this.i); }
    mark(i) { this.i = i; this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false')); }
  }

  /* ---------- buy box: purchase type + pack size ---------- */
  class BuyBox {
    constructor(form) {
      this.form = form;
      this.planInput = $('[data-selling-plan-input]', form);
      this.qtyInput = $('[data-quantity-input]', form);
      form.addEventListener('change', () => this.sync());
      this.sync();
    }
    sync() {
      const mode = $('[data-plan-mode]:checked', this.form);
      const isSub = mode ? mode.value === 'subscribe' : false;
      const freq = $('[data-plan-frequency]', this.form);
      if (this.planInput) this.planInput.value = isSub && freq ? freq.value : '';
      $$('[data-plan-only-sub]', this.form).forEach((el) => { el.hidden = !isSub; });

      const pack = $('[data-pack-qty]:checked', this.form);
      const qty = pack ? Number(pack.dataset.packQty) : Number(this.qtyInput?.value || 1);
      if (this.qtyInput) this.qtyInput.value = qty;
      const gross = pack ? Number(pack.dataset.packGross) : Number(this.form.dataset.unitPrice || 0) * qty;
      const net = pack ? Number(pack.dataset.packNet) : gross;

      // Pack prices come from Kaching's deal on both purchase types; subscription takes a further % off.
      const shown = isSub ? subPrice(net) : net;
      const label = $('[data-atc-label]', this.form);
      if (label) label.textContent = (isSub ? 'Subscribe' : 'Add to bag') + ' · ' + money(shown);
      const per = $('[data-atc-per]', this.form);
      if (per && this.form.dataset.unitCount) per.textContent = money(Math.round(shown / (qty * Number(this.form.dataset.unitCount)))) + ' per patch';
      $$('[data-atc-note-sub]', this.form).forEach((el) => el.hidden = !isSub);
      $$('[data-pack-sub-price]', this.form).forEach((el) => {
        const n = Number(el.dataset.packNet);
        el.textContent = money(isSub ? subPrice(n) : n);
      });
      $$('[data-pack-save]', this.form).forEach((el) => {
        const n = Number(el.dataset.packNet);
        el.textContent = 'Save ' + money(Number(el.dataset.packGross) - (isSub ? subPrice(n) : n));
      });
      $$('[data-pack-was]', this.form).forEach((el) => { el.classList.toggle('is-off', !isSub && el.dataset.hideOnetime === 'true'); });
      document.dispatchEvent(new CustomEvent('ptw:plan:changed', { detail: { sellingPlan: this.planInput ? this.planInput.value : '' } }));
    }
  }

  /* ---------- bundle builder ---------- */
  class Builder {
    constructor(root) {
      this.root = root; this.size = Number(root.dataset.bundleSize || 3); this.picks = [];
      root.addEventListener('click', (e) => {
        const tile = e.target.closest('[data-builder-tile]'); if (tile) { e.preventDefault(); this.toggle(tile); }
        const x = e.target.closest('[data-builder-unpick]'); if (x) { this.picks.splice(Number(x.dataset.builderUnpick), 1); this.paint(); }
        const clear = e.target.closest('[data-builder-clear]'); if (clear) { this.picks = []; this.paint(); }
        const add = e.target.closest('[data-builder-add]'); if (add) { e.preventDefault(); this.add(add); }
      });
      root.addEventListener('change', () => this.paint());
      this.paint();
    }
    toggle(tile) {
      const id = tile.dataset.variantId; const idx = this.picks.findIndex((p) => p.id === id);
      if (idx > -1) this.picks.splice(idx, 1);
      else { if (this.picks.length >= this.size) this.picks.shift(); this.picks.push({ id, product: tile.dataset.productId, title: tile.dataset.title, image: tile.dataset.image, price: Number(tile.dataset.price), color: tile.dataset.color }); }
      this.paint();
    }
    paint() {
      $$('[data-builder-tile]', this.root).forEach((t) => { const on = this.picks.some((p) => p.id === t.dataset.variantId); t.classList.toggle('is-picked', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      const prev = this.shown || [];
      $$('[data-builder-slot]', this.root).forEach((slot, i) => {
        const p = this.picks[i]; slot.classList.toggle('is-full', !!p);
        slot.classList.toggle('is-new', !!p && prev[i] !== p.id);
        slot.innerHTML = p ? '<img src="' + p.image + '" alt="' + p.title + '"><button type="button" class="bslot__x" data-builder-unpick="' + i + '" aria-label="Remove ' + p.title + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' : '<span class="num">' + (i + 1) + '</span>';
        if (p) slot.style.setProperty('--goal', p.color);
      });
      this.shown = this.picks.map((p) => p.id);
      const plan = $('[data-builder-plan]:checked', this.root); const isSub = plan && plan.value;
      const gross = this.picks.reduce((a, p) => a + p.price, 0);
      const full = this.picks.length >= this.size;
      const packOff = full ? gross - bundleNet(gross, this.picks.length, false) : 0;
      const net = full ? bundleNet(gross, this.picks.length, isSub) : (isSub ? subPrice(gross) : gross);
      const discount = gross - net;
      const g = $('[data-builder-gross]', this.root), n = $('[data-builder-net]', this.root), s = $('[data-builder-save]', this.root);
      if (g) { g.textContent = money(gross); g.hidden = discount === 0; }
      if (n) n.textContent = money(net);
      if (s) { s.textContent = (packOff ? 'Pack price' : '') + (packOff && isSub ? ' + ' : '') + (isSub ? 'subscriber ' + cfg.sub_percent + '% off' : '') + ': save ' + money(discount); s.hidden = discount === 0; }
      const btn = $('[data-builder-add]', this.root);
      if (btn) { const short = this.size - this.picks.length; btn.disabled = short > 0; btn.textContent = short > 0 ? 'Choose ' + short + ' more' : (isSub ? 'Subscribe' : 'Add pack') + ' · ' + money(net); }
      const c = $('[data-builder-count]', this.root); if (c) c.textContent = this.picks.length + '/' + this.size;
    }
    async add(btn) {
      if (this.picks.length < this.size) return;
      btn.classList.add('loading');
      try {
        const plan = $('[data-builder-plan]:checked', this.root);
        await cart.add(bundleLines(this.picks.map((p) => ({ variant: p.id, product: p.product, plan: plan && plan.value })), 'Build your own pack'));
        cart.open(); this.picks = []; this.paint();
      } catch (err) { toast(err.message); } finally { btn.classList.remove('loading'); }
    }
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bundle-add]'); if (!btn) return;
    e.preventDefault(); let units; try { units = JSON.parse(btn.dataset.bundleAdd); } catch (_) { return; }
    if (!units || !units.length) return;
    btn.classList.add('loading');
    try {
      const planSel = btn.closest('[data-bundle]')?.querySelector('[data-bundle-plan]:checked');
      const plan = planSel && planSel.value ? planSel.value : btn.dataset.sellingPlan;
      await cart.add(bundleLines(units.map((u) => ({ variant: u.variant, product: u.product, plan })), btn.dataset.bundleName || 'Bundle'));
      cart.open();
    } catch (err) { toast(err.message); } finally { btn.classList.remove('loading'); }
  });

  /* ---------- find your patch quiz ---------- */
  class Quiz {
    constructor(root) {
      this.root = root;
      const section = root.closest('section');
      try {
        this.questions = JSON.parse($('[data-quiz-questions]', section).textContent);
        this.products = JSON.parse($('[data-quiz-products]', section).textContent);
      } catch (_) { return; }
      this.packSize = Number(root.dataset.packSize || 3);
      this.questions.forEach((q) => q.answers.forEach((a) => { a.scores = Quiz.parse(a.goals); }));
      this.questions = this.questions.filter((q) => q.answers.length);
      this.intro = $('[data-quiz-intro]', root); this.stepEl = $('[data-quiz-step]', root); this.resultEl = $('[data-quiz-result]', root);
      root.addEventListener('click', (e) => {
        if (e.target.closest('[data-quiz-start]')) this.start();
        else if (e.target.closest('[data-quiz-restart]')) this.start();
        else if (e.target.closest('[data-quiz-back]')) this.back();
        else if (e.target.closest('[data-quiz-answer]')) this.answer(Number(e.target.closest('[data-quiz-answer]').dataset.quizAnswer));
        else if (e.target.closest('[data-quiz-add-pack]')) this.addPack(e.target.closest('[data-quiz-add-pack]'));
        else if (e.target.closest('[data-quiz-add-one]')) this.addOne(e.target.closest('[data-quiz-add-one]'));
      });
      root.addEventListener('change', (e) => { if (e.target.matches('[data-quiz-plan]')) this.paintTotals(); });
    }
    static parse(str) {
      const out = {};
      String(str || '').split(',').forEach((part) => {
        const [k, v] = part.split(':').map((s) => (s || '').trim().toLowerCase());
        if (k) out[k] = (out[k] || 0) + (Number(v) || 1);
      });
      return out;
    }
    show(el) { [this.intro, this.stepEl, this.resultEl].forEach((s) => { s.hidden = s !== el; }); }
    scrollTop() {
      const top = this.root.getBoundingClientRect().top;
      const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-offset')) || 0;
      if (top < offset || top > window.innerHeight * 0.4) window.scrollTo({ top: window.scrollY + top - offset - 16, behavior: 'smooth' });
    }
    start() { this.picks = []; this.i = 0; this.show(this.stepEl); this.paintStep(); this.scrollTop(); }
    back() { if (this.i === 0) { this.show(this.intro); return; } this.i--; this.picks.pop(); this.paintStep(); }
    answer(n) {
      this.picks[this.i] = n;
      if (this.i < this.questions.length - 1) { this.i++; this.paintStep(); this.scrollTop(); } else this.finish();
    }
    paintStep() {
      const q = this.questions[this.i], total = this.questions.length;
      $('[data-quiz-count]', this.root).textContent = 'Question ' + (this.i + 1) + ' of ' + total;
      $('[data-quiz-bar]', this.root).style.width = Math.round((this.i / total) * 100) + '%';
      const h = $('[data-quiz-question]', this.root); h.textContent = q.q;
      const help = $('[data-quiz-help]', this.root); help.textContent = q.help || ''; help.hidden = !q.help;
      const wrap = $('[data-quiz-answers]', this.root);
      wrap.innerHTML = '';
      q.answers.forEach((a, n) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'quiz__answer'; b.dataset.quizAnswer = n; b.textContent = a.label;
        if (this.picks[this.i] === n) b.setAttribute('aria-pressed', 'true');
        wrap.appendChild(b);
      });
      wrap.classList.toggle('is-long', q.answers.length > 4);
      h.focus({ preventScroll: true });
    }
    rank() {
      const scores = {}, order = [];
      this.picks.forEach((n, qi) => {
        const s = this.questions[qi].answers[n].scores;
        Object.keys(s).forEach((g) => { scores[g] = (scores[g] || 0) + s[g]; if (order.indexOf(g) < 0) order.push(g); });
      });
      // Highest score first; ties go to whichever goal the shopper mentioned earliest,
      // then to goals that pair well with their strongest one.
      const top = Object.keys(scores).sort((a, b) => scores[b] - scores[a] || order.indexOf(a) - order.indexOf(b))[0];
      const near = Quiz.PAIRS[top] || [];
      order.push(...near.filter((g) => order.indexOf(g) < 0));
      const seen = {};
      return this.products
        .map((p, idx) => ({ p, s: scores[p.goal] || 0, o: order.indexOf(p.goal) < 0 ? 99 : order.indexOf(p.goal), idx }))
        .sort((a, b) => b.s - a.s || a.o - b.o || a.idx - b.idx)
        .filter((r) => { if (seen[r.p.goal]) return false; seen[r.p.goal] = true; return true; })
        .map((r) => r.p);
    }
    finish() {
      const ranked = this.rank(); if (!ranked.length) return;
      this.match = ranked[0]; this.pack = ranked.slice(0, this.packSize);
      const m = this.match, esc = Quiz.esc, why = this.questions[0] && this.picks[0] != null ? this.questions[0].answers[this.picks[0]].label : '';
      $('[data-quiz-match]', this.root).innerHTML =
        '<div class="qmatch__media"><img src="' + esc(m.image) + '" alt="' + esc(m.title) + '" width="700" height="875"></div>' +
        '<div class="qmatch__body" style="--goal:' + esc(m.color) + '">' +
          '<span class="badge">' + esc(m.label) + '</span>' +
          '<h2 class="h1">' + esc(m.title) + '</h2>' +
          '<p class="lead">' + esc(m.promise) + '</p>' +
          (why ? '<p class="qmatch__why">' + '<span class="mono muted">You said</span> “' + esc(why) + '”</p>' : '') +
          '<p class="qmatch__price"><strong>' + money(m.price) + '</strong>' + (m.plan && cfg.sub_percent ? ' <span class="muted">or ' + money(subPrice(m.price)) + ' when you subscribe</span>' : '') + '</p>' +
          '<div class="qmatch__ctas"><button type="button" class="btn btn--dark" data-quiz-add-one="' + m.variant + '">Add to bag</button><a class="btn btn--outline" href="' + esc(m.url) + '">See details</a></div>' +
        '</div>';
      $('[data-quiz-pack]', this.root).innerHTML = this.pack.map((p, k) =>
        '<a class="qpack__item" href="' + esc(p.url) + '" style="--goal:' + esc(p.color) + '">' +
          '<span class="qpack__img"><img src="' + esc(p.image) + '" alt="" loading="lazy" width="200" height="250"></span>' +
          '<span class="qpack__name"><strong>' + esc(p.short) + '</strong><small>' + (k === 0 ? 'Your match' : esc(p.label)) + '</small></span>' +
        '</a>').join('');
      $('[data-quiz-bar]', this.root).style.width = '100%';
      this.show(this.resultEl); this.paintTotals(); this.scrollTop();
      $('[data-quiz-match]', this.root).focus({ preventScroll: true });
    }
    isSub() { const r = $('[data-quiz-plan]:checked', this.root); return !!(r && r.value); }
    paintTotals() {
      if (!this.pack) return;
      const isSub = this.isSub() && this.pack.every((p) => p.plan);
      const gross = this.pack.reduce((a, p) => a + p.price, 0);
      const net = bundleNet(gross, this.pack.length, isSub);
      const g = $('[data-quiz-gross]', this.root); g.textContent = money(gross); g.hidden = net === gross;
      $('[data-quiz-net]', this.root).textContent = money(net);
      const s = $('[data-quiz-save]', this.root); s.textContent = net < gross ? 'You save ' + money(gross - net) : '';
      $('[data-quiz-add-pack]', this.root).textContent = (isSub ? 'Subscribe to all ' : 'Add all ') + this.pack.length + ' · ' + money(net);
    }
    async addPack(btn) {
      btn.classList.add('loading');
      try {
        const isSub = this.isSub() && this.pack.every((p) => p.plan);
        await cart.add(bundleLines(this.pack.map((p) => ({ variant: p.variant, product: p.product, plan: isSub ? p.plan : null })), 'Quiz pack'));
        cart.open();
      } catch (err) { toast(err.message); } finally { btn.classList.remove('loading'); }
    }
    async addOne(btn) {
      btn.classList.add('loading');
      try { await cart.add({ id: Number(btn.dataset.quizAddOne), quantity: 1 }); cart.open(); }
      catch (err) { toast(err.message); } finally { btn.classList.remove('loading'); }
    }
    static get PAIRS() {
      return { sleep: ['calm', 'mood'], calm: ['sleep', 'mood'], mood: ['energy', 'calm'], energy: ['mood', 'appetite'], appetite: ['energy', 'glow'], glow: ['longevity', 'appetite'], longevity: ['glow', 'energy'] };
    }
    static esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
  }

  /* ---------- rails ---------- */
  function initRails() {
    $$('[data-rail]').forEach((wrap) => {
      const rail = $('.rail', wrap) || wrap;
      $$('[data-rail-nav]', wrap).forEach((b) => b.addEventListener('click', () => {
        const step = (rail.firstElementChild?.getBoundingClientRect().width || 300) + 20;
        rail.scrollBy({ left: step * Number(b.dataset.railNav), behavior: 'smooth' });
      }));
    });
  }

  /* ---------- tabs ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach((root) => {
      const tabs = $$('[role=tab]', root), panels = $$('[role=tabpanel]', root);
      tabs.forEach((t, i) => t.addEventListener('click', () => {
        tabs.forEach((x, k) => x.setAttribute('aria-selected', k === i ? 'true' : 'false'));
        panels.forEach((p, k) => p.classList.toggle('is-on', k === i));
      }));
    });
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) { $$('.reveal').forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ents) => ents.forEach((en, i) => { if (en.isIntersecting) { setTimeout(() => en.target.classList.add('is-in'), i * 60); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach((el) => io.observe(el));
  }

  /* ---------- announcement rotator (mobile) ---------- */
  function initAnnounce() {
    const track = $('[data-announce]'); if (!track) return;
    const items = $$('.announce__item', track); if (items.length < 2) return;
    let i = 0; items[0].classList.add('is-on');
    if (window.innerWidth >= 900) return;
    setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4200);
  }

  /* ---------- collection chip filters ---------- */
  function initFilters() {
    $$('[data-filter-group]').forEach((group) => {
      group.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-filter]'); if (!chip) return;
        $$('[data-filter]', group).forEach((c) => c.setAttribute('aria-pressed', 'false'));
        chip.setAttribute('aria-pressed', 'true');
        const val = chip.dataset.filter; let shown = 0;
        $$(group.dataset.filterTarget + ' [data-goal]').forEach((card) => { const on = val === 'all' || card.dataset.goal === val; card.hidden = !on; if (on) shown++; });
        const c = $('[data-filter-count]'); if (c) c.textContent = shown + (shown === 1 ? ' patch' : ' patches');
      });
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    $$('[data-hero]').forEach((el) => { if (!el.__ptw) { el.__ptw = new Hero(el); } });
    $$('[data-gallery]').forEach((el) => { if (!el.__ptw) el.__ptw = new Gallery(el); });
    $$('[data-product-form]').forEach((el) => { if (!el.__ptw) el.__ptw = new BuyBox(el); });
    $$('[data-bundle-builder]').forEach((el) => { if (!el.__ptw) el.__ptw = new Builder(el); });
    $$('[data-quiz]').forEach((el) => { if (!el.__ptw) el.__ptw = new Quiz(el); });
    initRails(); initTabs(); initReveal(); initAnnounce(); initFilters();
    cart.fetchState().then(() => cart.paintCount()).catch(() => {});
  }
  let headerInit = false;
  function start() { if (!headerInit) { initHeader(); headerInit = true; } boot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', boot);
})();
